export default [

  {path: '/errorPage',name: 'errorPage',meta: {title: '非法进入'},component: resolve => { require(['../components-other/error_page/error-page.vue'], resolve) }}, // 非法进入
  {path: '/messagePage',name: 'messagePage',meta: {title: '信息提示'},component: resolve => { require(['../components-other/tip/message-page.vue'], resolve) }},
  {path: '/*',name: 'error_404',meta: {title: '404-页面不存在'},component: resolve => { require(['../components-other/error_page/404.vue'], resolve) }}
]



// WEBPACK FOOTER //
// ./src/router/other.js